import { msg } from '@lingui/core/macro';
import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

// Leve de propósito: entra no arquivo da rota, que vai para o bundle inicial (A01). Só zod, Lingui e
// `shared/patterns/list-search` direto (nunca o barril).

/** Caminho do menu (`navigation.ts`: `/cadastro/gestao`): é por ele que `screens.byPath` acha a tela. */
export const BILLING_PRODUCT_PATH = '/cadastro/gestao';

/** Caminhos das abas no legado (`router.tsx:1819, 1832`); hoje redirecionam para `?tab=`. */
export const LEGACY_TAB_PATHS = {
  products: '/cadastro/gestao/produtos-cobranca',
  costs: '/cadastro/gestao/produtos-cobranca/parametros-custos',
} as const;

/** Abas do legado, na mesma ordem e com o rótulo visível da `TabBar` (`Product/index.tsx:5-8`, U44). */
export const BILLING_PRODUCT_TABS = [
  { id: 'produtos-cobranca', label: msg`Produtos cobrança`, icon: 'receipt-text' },
  { id: 'parametros-custos', label: msg`Parâmetros/custos cobrança`, icon: 'wallet' },
] as const;
export type BillingProductTab = (typeof BILLING_PRODUCT_TABS)[number]['id'];
export const COSTS_TAB = 'parametros-custos' satisfies BillingProductTab;

/** Painéis de criar/editar (`?sheet=`, U26): o voltar do navegador fecha. */
export const PRODUCT_SHEET = 'produto';
export const COSTS_SHEET = 'custos';

/**
 * URL do hub: aba (`?tab=`, a primeira não vai para a URL), página e tamanho da lista da aba ativa,
 * o painel aberto e o registro em edição (`editar`), que sobrevive ao F5.
 */
export const billingProductSearch = listSearchSchema({
  tab: z.enum([COSTS_TAB]).optional().catch(undefined),
  sheet: z.enum([PRODUCT_SHEET, COSTS_SHEET]).optional().catch(undefined),
  editar: z.string().min(1).max(64).optional().catch(undefined),
});
export type BillingProductSearch = z.infer<typeof billingProductSearch>;
